<template>
  <div class="userContent">
    <img
      src="../../assets/img/main/lun2.png"
      alt=""
      style="height:100%;width:100%;"
    />
    <div class="usermeans">
      <el-tabs
        v-model="activeName"
        :tab-position="tabPosition"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="$t('personal.selfcony')" name="1">
          <identifyConp v-if="identify"></identifyConp>
        </el-tab-pane>
        <el-tab-pane :label="$t('personal.identify')" name="2">
          <selfData v-if="selfcony"></selfData>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import identifyConp from "../../components/identifyConp";
import selfData from "../../components/selfData";
export default {
  components: {
    identifyConp,
    selfData
  },
  data() {
    return {
      tabPosition: "left",
      activeName: "1",
      identify: true,
      selfcony: false,
    };
  },
  created() {
  },
  mounted() {
    if (this.activeName == "1") {
      this.identify = true;
      console.log(2222)
    } else if (this.activeName == "2") {
      this.selfcony = true;
      console.log(3333)
    }
  },
  methods: {
    handleClick(val) {
      if (val.name == "1") {
        console.log(val);
        this.identify = true;
        this.selfcony = false;
      } else {
        this.selfcony = true;
        this.identify = false;
      }
    }
  }
};
</script>
<style lang="scss">
.userContent {
  .titles {
    margin: 10px 60px;
    .el-breadcrumb__item {
      .el-breadcrumb__inner {
        font-size: 16px;
      }
    }
  }
  .usermeans {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .el-tabs__header.is-left{
    background-color: rgb(232, 239, 235);
    padding-top: 60px;
    box-sizing: border-box;
  }
  .el-tabs__item{
    color: #333;
    font-size: 20px;
  }
  .el-tabs__item.is-active{
    background-color: #1d5a33;
    color:#fff;
  }
  .el-button--success.is-disabled, .el-button--success.is-disabled:active, .el-button--success.is-disabled:focus, .el-button--success.is-disabled:hover{
     background-color: #1d5a33;
  }
  .el-step__head.is-finish{
    color: #1d5a33;
    border-color: #1d5a33;
  }
  .el-step__title.is-finish{
      color: #1d5a33;
      // font-weight: 700;
  }
  .el-step__title.is-process{
    font-weight: 400;
  }
  .el-tabs--left .el-tabs__item.is-left{
    text-align: center;
    width: 100%;
  }
  .el-tabs--left .el-tabs__header.is-left{
    width: 300px;
  }
  .el-tabs__nav{
    width: 300px;
  }
}
</style>
